import { spawn, takeLatest, put, all, call } from 'redux-saga/effects';
import { encuestaActions } from '../../../../application/actions/encuesta';
import { loadersActions } from '../../../../application/actions/ui_loaders';
import api from '../../../api';

const apiEncuesta = api(process.env.REACT_APP_URL);

export function* encuestaFetch(params) {
  try {
    const trackId = window.localStorage.getItem('track_id');
    const endpoint = 'encuesta/registrar';

    const optionalsHeaders = {
      Authorization: `Bearer ${trackId}`,
      track_id: trackId
    };

    yield put(loadersActions.changeStatusLoaderEncuesta({ isLoading: true }));

    const { data } = yield call(apiEncuesta.post, endpoint, params.payload, optionalsHeaders);

    yield put(loadersActions.changeStatusLoaderEncuesta({ isLoading: false }));

    if (data && 'code' in data && data.code !== 1) {
      yield put(encuestaActions.encuestaCorrecta({ responseEncuesta: data }));
    } else if (data && data.code === 1) {
      yield put(encuestaActions.encuestaError({ responseEncuesta: data }));
    } else {
      yield put(encuestaActions.encuestaError({ responseEncuesta: { code: -1 } }));
    }
  } catch (error) {
    yield all([put(encuestaActions.encuestaError({ responseEncuesta: { error } }))]);
  }
}

export function* watchFetchEncuesta() {
  yield takeLatest(encuestaActions.encuesta.type, encuestaFetch);
}

export default function* rootSaga() {
  yield spawn(watchFetchEncuesta);
}
